import { render, staticRenderFns } from "./personManage.vue?vue&type=template&id=2a36ee12&scoped=true&"
import script from "./personManage.vue?vue&type=script&lang=js&"
export * from "./personManage.vue?vue&type=script&lang=js&"
import style0 from "./personManage.vue?vue&type=style&index=0&id=2a36ee12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a36ee12",
  null
  
)

export default component.exports